import { QueryClient } from '@tanstack/react-query';

// TanStack Query default options.
// AP-11: 서버 상태 ≠ UI 상태. 캐시 정책은 feature 에서 override.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
